// extracted by css-extract-rspack-plugin
export default {"grabbing":"grabber-module__grabbing___voztM"};